$(function(){
  $('#share-button').on('click', function(){
    if (navigator.share) {
      const title = document.title;
      const header = document.querySelector("header").innerText;
      // If Web Share API is supported, enable the Web Share API button
      const shareButton = document.getElementById("share-button");
      shareButton.style.display = "block"; // Show the button
      shareButton.addEventListener("click", () => {

        navigator
          .share({
            title,
            text: header,
            url: window.location.href,
          })
          .then(() => console.log("Shared successfully"))
          .catch((error) => console.error("Sharing failed:", error));
      });
    } else {
      // Enable the sharing links button
      const linkContainer = document.getElementById("share-links");
      linkContainer.style.display = "block";
    }

    function popUpShare(sharingURL) {
      // Open a new pop-up window with the sharing URL.
      window.open(sharingURL, 'CustomShareWindow', 'width=500, height=400, left=400, top=100');
    }

    const facebook = document.getElementById("facebook");
    const twitter = document.getElementById("twitter");

    facebook.addEventListener("click", ()=> popUpShare(
      "https://www.facebook.com/sharer/sharer.php?u=https://example.com"
      ));
    twitter.addEventListener("click", ()=> popUpShare(
      "https://twitter.com/intent/tweet?text=Check%20out%20this%20awesome%20content&url=https://example.com"
      ));
  });
});


